import { DateTime } from "luxon";
import { InputDate } from "@goodfill/ui-components";

export type DateRange = [DateTime | null, DateTime | null];

export function DateRangeFilter({
  value,
  onChange,
  timezone,
  small,
}: {
  value: DateRange;
  onChange: (value: DateRange) => void;
  timezone: string;
  small?: boolean;
}) {
  return (
    <div className="flex flex-row">
      <InputDate
        small={small}
        border="neutral"
        value={value[0]?.toFormat("yyyy-MM-dd") ?? ""}
        setValue={(newSince) => {
          onChange([newSince === "" ? null : DateTime.fromISO(`${newSince}T00:00:00`, { zone: timezone }), value[1]]);
        }}
      />
      <InputDate
        small={small}
        border="neutral"
        value={value[1]?.toFormat("yyyy-MM-dd") ?? ""}
        setValue={(newTill) => {
          onChange([
            value[0],
            newTill === ""
              ? null
              : DateTime.fromISO(`${newTill}T23:59:59`, { zone: timezone }).set({ millisecond: 999 }),
          ]);
        }}
      />
    </div>
  );
}
